module.exports = __webpack_public_path__ + "eg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/eg.svg
// module id = 531
// module chunks = 0